import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { normalizeCategory } from "../data/services";

const ServicesContext = createContext({ services: [], pandit: null, loading: true, getBySlug: () => undefined });

export function ServicesProvider({ children }) {
  const [services, setServices] = useState([]);
  const [pandit, setPandit] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    api
      .get("/services")
      .then(({ data }) => {
        if (!active) return;
        const all = Array.isArray(data) ? data : [];
        setServices(all.filter((c) => c.kind !== "pandit").map(normalizeCategory));
        setPandit(all.find((c) => c.kind === "pandit") || null);
      })
      .catch(() => {})
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, []);

  const getBySlug = (slug) => services.find((s) => s.slug === slug);

  return (
    <ServicesContext.Provider value={{ services, pandit, loading, getBySlug }}>
      {children}
    </ServicesContext.Provider>
  );
}

export const useServices = () => useContext(ServicesContext);
